import { usePathname } from "expo-router";
import React, { useEffect } from "react";
import Toast from "react-native-toast-message";

export default function ToastReset() {
  const route = usePathname();
  const exceptionRoutes = ["/", "/corporation/addindividual"];

  useEffect(() => {
    if (!exceptionRoutes.includes(route)) {
      Toast.hide();
    }
  }, [route]);

  return <></>;
}
